/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrBalloonEntity } from '../../models/dbr-balloon-entity';
import { DbrUpdateBalloonImageDto } from '../../models/dbr-update-balloon-image-dto';

export interface BalloonsControllerUpdateImage$Params {
  balloonCode: string;
      body: DbrUpdateBalloonImageDto
}

export function balloonsControllerUpdateImage(http: HttpClient, rootUrl: string, params: BalloonsControllerUpdateImage$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrBalloonEntity>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerUpdateImage.PATH, 'patch');
  if (params) {
    rb.path('balloonCode', params.balloonCode, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrBalloonEntity>;
    })
  );
}

balloonsControllerUpdateImage.PATH = '/balloons/image/{balloonCode}';
